import React, { useState, useEffect } from "react";
import SearchTop from "./SearchTop";
import SearchSearch from "./SearchSearch";
import SearchTree from "./SearchTree";


const Search = ({TnvedOpen}) => {
    const [check1, setCheck1] = useState(true);
    const [check2, setCheck2] = useState(false);


    return (
        <>
            <SearchTop 
                check1={check1}
                setCheck1={setCheck1}
                check2={check2}
                setCheck2={setCheck2}
                TnvedOpen={TnvedOpen} 
            />
            <div className="sm:mt-[40px] mt-[29px] mb-[20px]">
                {check1 && <SearchSearch />}
                {check2 && <SearchTree />} 
            </div>
        </>
    );
}

export default Search;